// Studyo Today Backend
// Package studyo.today.schools.v1
// Service definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/school_schedules.proto (package studyo.today.schools.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schedules_v1_resources_schedule_cycle } from "@buf/studyo_studyo-today-schedules.bufbuild_es/studyo/today/schedules/v1/resources/schedule_cycle_pb.js";

/**
 * Describes the file studyo/today/schools/v1/school_schedules.proto.
 */
export const file_studyo_today_schools_v1_school_schedules = /*@__PURE__*/
  fileDesc("Ci5zdHVkeW8vdG9kYXkvc2Nob29scy92MS9zY2hvb2xfc2NoZWR1bGVzLnByb3RvEhdzdHVkeW8udG9kYXkuc2Nob29scy52MSKSAQoXR2V0U2NoZWR1bGVDeWNsZVJlcXVlc3QSGQoRc2NoZWR1bGVfY3ljbGVfaWQYASABKAkSEQoJc2Nob29sX2lkGAIgASgJEhoKEGRyYWZ0X3Nlc3Npb25faWQYAyABKAlIABIkChphbGxvd19kcmFmdF9zY2hlZHVsZV9jeWNsZRgEIAEoCEgAQgcKBWRyYWZ0IqQBChhHZXRTY2hlZHVsZUN5Y2xlUmVzcG9uc2USSgoOc2NoZWR1bGVfY3ljbGUYASABKAsyMi5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5TY2hlZHVsZUN5Y2xlEhgKEGRyYWZ0X3Nlc3Npb25faWQYAiABKAkSIgoaYXZhaWxhYmxlX2RyYWZ0X3Nlc3Npb25faWQYAyABKAkigwEKIlB1Ymxpc2hJbml0aWFsU2NoZWR1bGVDeWNsZVJlcXVlc3QSSgoOc2NoZWR1bGVfY3ljbGUYASABKAsyMi5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5TY2hlZHVsZUN5Y2xlEhEKCXNjaG9vbF9pZBgCIAEoCSKWAQojUHVibGlzaEluaXRpYWxTY2hlZHVsZUN5Y2xlUmVzcG9uc2USSgoOc2NoZWR1bGVfY3ljbGUYASABKAsyMi5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5TY2hlZHVsZUN5Y2xlEiMKG2F0dGFjaGVkX3NjaGVkdWxlX2N5Y2xlX2lkcxgCIAMoCSKYAQodU2F2ZURyYWZ0U2NoZWR1bGVDeWNsZVJlcXVlc3QSSgoOc2NoZWR1bGVfY3ljbGUYASABKAsyMi5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5TY2hlZHVsZUN5Y2xlEhEKCXNjaG9vbF9pZBgCIAEoCRIYChBkcmFmdF9zZXNzaW9uX2lkGAMgASgJIo4BCh5TYXZlRHJhZnRTY2hlZHVsZUN5Y2xlUmVzcG9uc2USSgoOc2NoZWR1bGVfY3ljbGUYASABKAsyMi5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5TY2hlZHVsZUN5Y2xlEiAKGGhhc19tb3JlX3JlY2VudF9yZXZpc2lvbhgCIAEoCCJqCiBQdWJsaXNoRHJhZnRTY2hlZHVsZUN5Y2xlUmVxdWVzdBIZChFzY2hlZHVsZV9jeWNsZV9pZBgBIAEoCRIRCglzY2hvb2xfaWQYAiABKAkSGAoQZHJhZnRfc2Vzc2lvbl9pZBgDIAEoCSKMAQohUHVibGlzaERyYWZ0U2NoZWR1bGVDeWNsZVJlc3BvbnNlEkoKDnNjaGVkdWxlX2N5Y2xlGAEgASgLMjIuc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMuU2NoZWR1bGVDeWNsZRIbChNoYXNfZHJvcHBlZF9jaGFuZ2VzGAIgASgIIm4KJERpc2NhcmRMYXN0RHJhZnRTY2hlZHVsZUN5Y2xlUmVxdWVzdBIZChFzY2hlZHVsZV9jeWNsZV9pZBgBIAEoCRIRCglzY2hvb2xfaWQYAiABKAkSGAoQZHJhZnRfc2Vzc2lvbl9pZBgDIAEoCSKFAQolRGlzY2FyZExhc3REcmFmdFNjaGVkdWxlQ3ljbGVSZXNwb25zZRJKCg5zY2hlZHVsZV9jeWNsZRgBIAEoCzIyLnN0dWR5by50b2RheS5zY2hlZHVsZXMudjEucmVzb3VyY2VzLlNjaGVkdWxlQ3ljbGUSEAoIaXNfZHJhZnQYAiABKAgibgokRGlzY2FyZEFsbERyYWZ0U2NoZWR1bGVDeWNsZXNSZXF1ZXN0EhkKEXNjaGVkdWxlX2N5Y2xlX2lkGAEgASgJEhEKCXNjaG9vbF9pZBgCIAEoCRIYChBkcmFmdF9zZXNzaW9uX2lkGAMgASgJInMKJURpc2NhcmRBbGxEcmFmdFNjaGVkdWxlQ3ljbGVzUmVzcG9uc2USSgoOc2NoZWR1bGVfY3ljbGUYASABKAsyMi5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5TY2hlZHVsZUN5Y2xlMpQHCg9TY2hvb2xTY2hlZHVsZXMSeQoQR2V0U2NoZWR1bGVDeWNsZRIwLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLkdldFNjaGVkdWxlQ3ljbGVSZXF1ZXN0GjEuc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEuR2V0U2NoZWR1bGVDeWNsZVJlc3BvbnNlIgASmgEKG1B1Ymxpc2hJbml0aWFsU2NoZWR1bGVDeWNsZRI7LnN0dWR5by50b2RheS5zY2hvb2xzLnYxLlB1Ymxpc2hJbml0aWFsU2NoZWR1bGVDeWNsZVJlcXVlc3QaPC5zdHVkeW8udG9kYXkuc2Nob29scy52MS5QdWJsaXNoSW5pdGlhbFNjaGVkdWxlQ3ljbGVSZXNwb25zZSIAEosBChZTYXZlRHJhZnRTY2hlZHVsZUN5Y2xlEjYuc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEuU2F2ZURyYWZ0U2NoZWR1bGVDeWNsZVJlcXVlc3QaNy5zdHVkeW8udG9kYXkuc2Nob29scy52MS5TYXZlRHJhZnRTY2hlZHVsZUN5Y2xlUmVzcG9uc2UiABKUAQoZUHVibGlzaERyYWZ0U2NoZWR1bGVDeWNsZRI5LnN0dWR5by50b2RheS5zY2hvb2xzLnYxLlB1Ymxpc2hEcmFmdFNjaGVkdWxlQ3ljbGVSZXF1ZXN0Gjouc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEuUHVibGlzaERyYWZ0U2NoZWR1bGVDeWNsZVJlc3BvbnNlIgASoAEKHURpc2NhcmRMYXN0RHJhZnRTY2hlZHVsZUN5Y2xlEj0uc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEuRGlzY2FyZExhc3REcmFmdFNjaGVkdWxlQ3ljbGVSZXF1ZXN0Gj4uc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEuRGlzY2FyZExhc3REcmFmdFNjaGVkdWxlQ3ljbGVSZXNwb25zZSIAEqABCh1EaXNjYXJkQWxsRHJhZnRTY2hlZHVsZUN5Y2xlcxI9LnN0dWR5by50b2RheS5zY2hvb2xzLnYxLkRpc2NhcmRBbGxEcmFmdFNjaGVkdWxlQ3ljbGVzUmVxdWVzdBo+LnN0dWR5by50b2RheS5zY2hvb2xzLnYxLkRpc2NhcmRBbGxEcmFmdFNjaGVkdWxlQ3ljbGVzUmVzcG9uc2UiAEIfqgIcU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMWIGcHJvdG8z", [file_studyo_today_schedules_v1_resources_schedule_cycle]);

/**
 * Describes the message studyo.today.schools.v1.GetScheduleCycleRequest.
 * Use `create(GetScheduleCycleRequestSchema)` to create a new message.
 */
export const GetScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 0);

/**
 * Describes the message studyo.today.schools.v1.GetScheduleCycleResponse.
 * Use `create(GetScheduleCycleResponseSchema)` to create a new message.
 */
export const GetScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 1);

/**
 * Describes the message studyo.today.schools.v1.PublishInitialScheduleCycleRequest.
 * Use `create(PublishInitialScheduleCycleRequestSchema)` to create a new message.
 */
export const PublishInitialScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 2);

/**
 * Describes the message studyo.today.schools.v1.PublishInitialScheduleCycleResponse.
 * Use `create(PublishInitialScheduleCycleResponseSchema)` to create a new message.
 */
export const PublishInitialScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 3);

/**
 * Describes the message studyo.today.schools.v1.SaveDraftScheduleCycleRequest.
 * Use `create(SaveDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const SaveDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 4);

/**
 * Describes the message studyo.today.schools.v1.SaveDraftScheduleCycleResponse.
 * Use `create(SaveDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const SaveDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 5);

/**
 * Describes the message studyo.today.schools.v1.PublishDraftScheduleCycleRequest.
 * Use `create(PublishDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const PublishDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 6);

/**
 * Describes the message studyo.today.schools.v1.PublishDraftScheduleCycleResponse.
 * Use `create(PublishDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const PublishDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 7);

/**
 * Describes the message studyo.today.schools.v1.DiscardLastDraftScheduleCycleRequest.
 * Use `create(DiscardLastDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const DiscardLastDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 8);

/**
 * Describes the message studyo.today.schools.v1.DiscardLastDraftScheduleCycleResponse.
 * Use `create(DiscardLastDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const DiscardLastDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 9);

/**
 * Describes the message studyo.today.schools.v1.DiscardAllDraftScheduleCyclesRequest.
 * Use `create(DiscardAllDraftScheduleCyclesRequestSchema)` to create a new message.
 */
export const DiscardAllDraftScheduleCyclesRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 10);

/**
 * Describes the message studyo.today.schools.v1.DiscardAllDraftScheduleCyclesResponse.
 * Use `create(DiscardAllDraftScheduleCyclesResponseSchema)` to create a new message.
 */
export const DiscardAllDraftScheduleCyclesResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_school_schedules, 11);

/**
 * Service definition for the School Schedules API.
 *
 * @generated from service studyo.today.schools.v1.SchoolSchedules
 */
export const SchoolSchedules = /*@__PURE__*/
  serviceDesc(file_studyo_today_schools_v1_school_schedules, 0);

